import { useTechnologicalMap } from './useTechnologicalMap';

export { useTechnologicalMap };
